import { render } from "./IPSEditor.vue?vue&type=template&id=5e48bba9&scoped=true"
import script from "./IPSEditor.vue?vue&type=script&lang=js"
export * from "./IPSEditor.vue?vue&type=script&lang=js"

import "./IPSEditor.vue?vue&type=style&index=0&id=5e48bba9&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5e48bba9"]])

export default __exports__